import React from 'react';
import { useTranslation } from 'react-i18next';
import StatusTag from './StatusTag';
var BidStatusTag = function (_a) {
    var bid = _a.bid;
    var t = useTranslation().t;
    return (React.createElement(StatusTag, { className: bid.status }, t("params.bid.statuses.".concat(bid.status))));
};
export default BidStatusTag;
